import HrmStatusCard from "./HrmStatusCard";
import styles from "./HrmFillters.module.css";

const HrmFilters = ({
  mode,
  selectedFilter,
  headerData,
  handleClick,
  getData,
  type,
}) => {
  return (
    <>
      {headerData?.map((s, index) => (
        <div
          key={s.status + index}
          className={`${styles.order_filter} ${
            mode ? styles.order_filter_dark : ""
          } ${
            s.status === selectedFilter
              ? mode
                ? styles.order_filter_active_dark
                : styles.order_filter_active
              : ""
          }`}
          onClick={async () => {
            if (s.status === selectedFilter) {
              await getData();
            } else {
              handleClick(s.status);
            }
          }}
        >
          <HrmStatusCard
            mode={mode}
            statusText={s.status}
            statusItemCount={s.count}
            amount={s.amount}
            subtitle={s.subtitle}
          />
        </div>
      ))}
    </>
  );
};

export default HrmFilters;
